export default "__VITE_ASSET__43668ef5__"